const rejectEmail = {
  shiptoNo: 'shipto编号',
  shiptoName: 'shipto名称',
  primaryEmail: '主邮箱',
  primaryEmailValid: '主邮箱是否有效',
  backupEmail: '备用邮箱',
  backupEmailValid: '备用邮箱是否有效',
  msg: {}
};
export default rejectEmail;



// WEBPACK FOOTER //
// ./src/page/md/rejectEmail/lang/rejectEmail.zh.js